import React from 'react';
import Tooltip from "../../input/Tooltip";
import Start from "../../common/Start";

const EmployerStart = () => {
    return (
        <Start neededItems={['Employment details and records for the employee', 'Personal and contact information for the employee']}
               niceToHaveItems={[<>Your account number
                   <Tooltip text="You can find this 7-digit number in your policy booklet."/> and bill group number
                   <Tooltip
                       text="You can find this 5 digit number in your policy booklet, depending on what unit your employee is in."/></>]}/>
    )
};

export default EmployerStart;